import {React} from 'react';
import {Button, ButtonGroup, Card, CardContent, Typography} from '@material-ui/core';
import {makeStyles} from '@material-ui/core/styles';
import {FormattedMessage} from 'react-intl';
import messages from '@super-template/messages';
import {format} from 'date-fns';
import {getPrimary} from '../utils';
import getTranslated from '@super-template/core/src/locale/getTranslated';
import useLocale from '@super-template/core/src/locale/useLocale';
import Required from "@super-template/core/src/formFields/Required";
import {LotuModal} from "@super-template/core/src/LotuModal";

const useStyles = makeStyles(() => ({
  li: {
    listStyleType: "none",
  },
  card: {
    marginTop: "3px",
  }
}));

const translatedHolidays = (wishes, locale) =>
  wishes.map(w => ({
    ...w,
    holidayRestrictions: getTranslated(w.holidayRestrictions, locale),
    themeName: getTranslated(w.themeName, locale)
  }));

const WishList = ({wishArray, holiday}) => {
  const classes = useStyles();
  const primary = getPrimary();

  return (wishArray.map((wish) =>
    <Card key={wish.id} className={classes.card} variant="outlined">
      <CardContent>
        <Typography variant="body2"><FormattedMessage {...messages.primary} />: {wish.id === primary.id ?
          <FormattedMessage {...messages.true} /> : <FormattedMessage {...messages.false} />}</Typography>
        <Typography variant="body2">
          <FormattedMessage {...messages.date} />{': '}
          {format(new Date(wish.startDate), 'dd.MM.yyyy')}{' - '}{format(new Date(wish.endDate), 'dd.MM.yyyy')}
        </Typography>
        <Typography variant="body2">
          <FormattedMessage {...messages.target} />: {wish.resortOrganization.name}
        </Typography>
        <Typography variant="body2">
          <FormattedMessage {...messages.theme} />: {wish.themeName}
        </Typography>
        {wish.partnerOrganization && (
          wish.partnerOrganization.www ?
            <Typography variant="body2">
              <FormattedMessage {...messages.partner} />{': '}
              <a target={'_blank'} rel="noreferrer" href={wish.partnerOrganization.www}>
                {wish.partnerOrganization.name}
              </a>
            </Typography> :
            <Typography variant="body2">
              <FormattedMessage {...messages.partner} />: {wish.partnerOrganization.name}
            </Typography>)}
        {wish.holidayRestrictions &&
        <Typography variant="body2">
          <Required/>{' '}
          <strong>
            <FormattedMessage {...holiday ? messages.holiday_restrictions : messages.course_restrictions} />{': '}
          </strong>
          <strong>{wish.holidayRestrictions}</strong>
        </Typography>}
      </CardContent>
    </Card>
  ));
};
export default function WishConfirmModal({label = 'confirm', open, holiday, onClose, onConfirm, array, isHolidayOrganization}) {
  const [locale] = useLocale();
  array = translatedHolidays(array, locale);
  const hasRestrictions = array.find(w => w.holidayRestrictions);

  return (
    <LotuModal open={open} onClose={onClose} title={<FormattedMessage {...messages[label]} />}>
      <p><FormattedMessage {...messages[holiday ? 'confirm_holiday1' : 'confirm_course1']} /></p>
      <p><FormattedMessage {...messages[holiday ? 'confirm_holiday2' : 'confirm_course2']} /></p>
      <p><FormattedMessage {...messages[holiday ? 'confirm_holiday3' : 'confirm_course3']} /></p>
      <p><strong>
        {hasRestrictions ?
          <FormattedMessage {...isHolidayOrganization ? messages.confirm_holiday_restrictions : messages.confirm_course_restrictions} /> :
          <FormattedMessage {...isHolidayOrganization ? messages.holiday_wishes : messages.course_wishes} />}
      </strong></p>
      <WishList wishArray={array} holiday={isHolidayOrganization}/>
      <ButtonGroup style={{marginTop: 20, width: "100%", justifyContent: "right"}}>
        <Button autoFocus onClick={onClose} variant="outlined" color="primary">
          <FormattedMessage {...messages.edit} />
        </Button>
        <Button autoFocus onClick={onConfirm} variant="contained" color="primary">
          <FormattedMessage {...messages.confirm} />
        </Button>
      </ButtonGroup>
    </LotuModal>
  );
}
